// extracted by mini-css-extract-plugin
module.exports = {"container":"post-list-module--container--1ANXI","post":"post-list-module--post--39h-F","cover":"post-list-module--cover--2O8pN","content":"post-list-module--content--llWjm"};